import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../Img';

import styles from './ratingInfo.scss';
import { ratingTypes } from '../../../utils/constants';

const RangeInfoContent = props => {
    const { isMobile, cancelText, closePopUp } = props;
    return (
        <div className="pop-up-content">
            <div className={styles.titleWrapper}>
                <div className={styles.title}>{ratingTypes.tennis} Range</div>
                {!isMobile && (
                    <Img
                        alt="close"
                        src="/img/v2/icons/icon-close.svg"
                        className={styles.closeIcon}
                        onClick={closePopUp}
                    />
                )}
            </div>
            <div className="row mb24">
                <div className="col-5 col-md-4">
                    <div className={styles.rating}>
                        5.5-6.5
                    </div>
                </div>
                <div className="col-7 col-md-8">
                    <div className={styles.descTitle}>
                        Starting {ratingTypes.tennis} Range
                    </div>
                    <div className={styles.desc}>
                        The Starting {ratingTypes.tennis} Range is an estimate of your tennis level based on the questionnaire you answered during onboarding. It is designed to help you find other players who are close to your level to play with. It will also assist organizers in placing you in the appropriate groups / draws when you register for events.
                        <br />
                        Once you have played enough matches to have a reliable rating, your Starting {ratingTypes.tennis} Range will no longer be visible.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col-5 col-md-4">
                    <div className={styles.rating}>
                        6.3
                    </div>
                </div>
                <div className="col-7 col-md-8">
                    <div className={styles.descTitle}>
                        Last Reliable {ratingTypes.tennis}
                    </div>
                    <div className={styles.desc}>
                        The Last Reliable {ratingTypes.tennis} is the last known fully reliable rating we have for you in our system.
                    </div>
                </div>
            </div>
            <div className="text-right">
                <button
                    type="button"
                    onClick={closePopUp}
                    className={`btn btn-primary text-uppercase text-white`}
                >
                    <span>{cancelText}</span>
                </button>
            </div>
        </div>
    );
};

RangeInfoContent.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    cancelText: PropTypes.string.isRequired,
    closePopUp: PropTypes.func.isRequired,
};

export default RangeInfoContent;
